(($, Drupal) => {
    Drupal.behaviors.historySlider = {
        attach: function attach() {
            $("body").once("history-slider").each(function() {
                
                var synchronousSliders = function(el){
                    this.wrap = el;
                    this.masterSlider = this.wrap.querySelector('[data-master-slider]');
                    this.slaveSlider = this.wrap.querySelector('[data-slave-slider]');
                    this.draggedItem = null;
                    this.startX = null;
                    this.moveX = 0;

                    this.init = () => {
                        this.initSlider(this.slaveSlider, 'slave');
                        this.initSlider(this.masterSlider, 'master');
                        this.initThumbs();
                        this.initMouse();
                    }

                    this.initSlider = (slider, type) => {
                        $(slider).parent().addClass("owl-loaded");
                        $(slider).addClass('owl-loaded').owlCarousel(this.getConfig()[type]);
                    }

                    this.initThumbs = () => {
                        let _this = this,
                            masterSlider = $(this.masterSlider);

                        $(this.slaveSlider).find('.owl-item .title').on('click', () => {
                            let currItemInd = masterSlider.find('[data-item-index="' + $(event.target).closest('.date-item').attr('data-item-index') + '"]').closest('.owl-item').index();

                            _this.switchItem(masterSlider, currItemInd);
                        });
                    }

                    this.initMouse = () => {
                        $(this.masterSlider).on('mousemove', event => {
                            let top = event.pageY - 75,
                                left = event.pageX - 75;

                            $('.custom-cursor').css({'top': top + 'px', 'left': left + 'px'});
                        });
                    }

                    this.watchTranslate = event => {
                        (this.startX == null)
                            ? this.startX = event.pageX
                            : this.moveX = this.startX - event.pageX;

                        this.setTranslate(100 * ( this.moveX / this.wrap.offsetWidth ));
                    }


                    this.setTranslate = (percent) => {
                        let container = this.wrap;

                        if(percent == false){
                            container.style.removeProperty('--translateX');
                            container.style.removeProperty('--absTranslateX');
                        }else{
                            container.style.setProperty('--translateX', percent);
                            container.style.setProperty('--absTranslateX', Math.abs(percent));
                        }
                    }

                    this.watchTranslateMaster = event => {
                        (this.startX == null)
                            ? this.startX = event.pageX
                            : this.moveX = this.startX - event.pageX;

                        this.setTranslateMaster(400 * ( this.moveX / this.wrap.offsetWidth ));
                    }


                    this.setTranslateMaster = (percent) => {
                        let container = this.wrap;

                        if(percent == false){
                            container.style.removeProperty('--masterTranslateX');
                            container.style.removeProperty('--masterAbsTranslateX');
                        }else{
                            container.style.setProperty('--masterTranslateX', percent);
                            container.style.setProperty('--masterAbsTranslateX', Math.abs(percent));
                        }
                    }

                    this.switchItem = (slider, item) => {
                        slider.trigger('to.owl.carousel', [slider.data('owl.carousel').relative(item), 250, true]);
                    }

                    this.setClasses = slider => {
                        let activeItem = slider.find('.owl-item.active');

                        slider.find('.owl-item').removeClass('prev-item next-item side-item');
                        activeItem.prev().addClass('prev-item').prev().addClass('prev-item side-item');
                        activeItem.next().addClass('next-item').next().addClass('next-item side-item');
                    }

                    this.getConfig = () => {
                        let _this = this,
                            masterSlider = $(this.masterSlider),
                            slaveSlider = $(this.slaveSlider);

                        const _config = {
                            master: {
                                loop: false,
                                items: 1,
                                dots: false,
                                nav: true,
                                navContainerClass: "default__nav history-line__nav",
                                stagePadding: 110,

                                responsive: {
                                    0: {
                                        margin: 16,
                                        stagePadding: 0
                                    },
                                    1024: {
                                        margin: 32,
                                        stagePadding: 60
                                    },
                                    1280: {
                                        margin: 32,
                                        stagePadding: 80
                                    },
                                    1440: {
                                        margin: 32,
                                        stagePadding: 110
                                    }
                                },

                                onInitialize: function(e){
                                    _this.setClasses(slaveSlider);
                                },

                                onDrag: function(e) {
                                    document.addEventListener('mousemove', _this.watchTranslate);
                                },
                                onTranslate: function(e) {
                                    document.removeEventListener('mousemove', _this.watchTranslate);
                                    _this.startX = null;
                                    _this.setTranslate(false);


                                    let currItem = slaveSlider[0].querySelectorAll('.owl-item')[e.relatedTarget.current()],
                                        currItemInd = slaveSlider.find('[data-item-index="' + $(currItem).find('.date-item').attr('data-item-index') + '"]').closest('.owl-item').index();

                                    _this.switchItem(slaveSlider, currItemInd);
                                    _this.setClasses(slaveSlider);
                                }
                            },
                            slave: {
                                loop: false,
                                items: 1,/* 
                                mouseDrag: false,
                                touchDrag: false,
                                pullDrag: false, */
                                dots: false,
                                nav: false,
                                onDrag: function(e) {
                                    document.addEventListener('mousemove', _this.watchTranslateMaster);
                                    masterSlider.trigger('to.owl.carousel', [e.relatedTarget.current(), 250, true]);
                                    masterSlider.addClass("transform-transition")
                                    
                                },
                                onTranslated: function(e) {
                                    masterSlider.trigger('to.owl.carousel', [e.relatedTarget.current(), 0, true]);
                                    masterSlider.removeClass("transform-transition")
                                    _this.setClasses(slaveSlider);
                                },
                                onDragged: function(e) {
                                    masterSlider.trigger('to.owl.carousel', [e.relatedTarget.current(), 0, true]);
                                    masterSlider.removeClass("transform-transition")
                                    _this.setClasses(slaveSlider);
                                },
                                onTranslate: function(e) {
                                    document.removeEventListener('mousemove', _this.watchTranslateMaster);
                                    _this.startX = null;
                                    _this.setTranslateMaster(false);
                                    _this.setClasses(slaveSlider);

                                    
                                    
                                    
                                    /* _this.switchItem2(masterSlider, e.relatedTarget.current()) */
                                    /* let currItem = slaveSlider[0].querySelectorAll('.owl-item')[e.relatedTarget.current()],
                                        currItemInd = slaveSlider.find('[data-item-index="' + $(currItem).find('.date-item').attr('data-item-index') + '"]').closest('.owl-item').index();

                                    _this.switchItem(slaveSlider, currItemInd);
                                    _this.setClasses(slaveSlider); */
                                }
                            }
                        }

                        return _config;
                    }

                    return this.init();
                }

                document.querySelectorAll('[data-synchronous-slider]').forEach(el => new synchronousSliders(el));
            });
        }
    };

})(jQuery, Drupal);
  